import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ExtFieldPc.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/Base/SinglePicker.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c('Popup', {
    attrs: {
      "position": "right",
      "width": "100%",
      "show-mask": _vm.showMask
    },
    model: {
      value: _vm.currValue,
      callback: function ($$v) {
        _vm.currValue = $$v;
      },
      expression: "currValue"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('view-box', {
    ref: "viewBox",
    attrs: {
      "body-padding-bottom": 80
    }
  }, [_c('div', [_vm.isShowScan ? _c('Group', {
    nativeOn: {
      "click": function ($event) {
        _vm.showScan = true;
      }
    }
  }, [_c('div', {
    staticClass: "flex-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "/spa_static_mobile/icon/code24_23@3x.png"
    }
  }), _vm._v(" " + i18n.tc("571") + " ")])]) : _vm._e(), _c('group', [_c('x-input', {
    attrs: {
      "title": i18n.tc("197"),
      "placeholder": i18n.tc("572"),
      "show-clear": false
    },
    on: {
      "on-change": _vm.handleSearch
    },
    model: {
      value: _vm.form.productionSn,
      callback: function ($$v) {
        _vm.$set(_vm.form, "productionSn", $$v);
      },
      expression: "form.productionSn"
    }
  }, [_vm.DingTalk ? _c('div', {
    staticClass: "right-btn",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('div', {
    staticClass: "btn btn1",
    on: {
      "click": _vm.scan
    }
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "/spa_static_mobile/icon/code24_23@3x.png"
    }
  }), _c('span', [_vm._v(i18n.tc("573"))])])]) : _vm._e()])], 1), _c('group', [_c('x-input', {
    attrs: {
      "title": i18n.tc("209"),
      "placeholder": i18n.tc("239"),
      "show-clear": false,
      "readonly": ""
    },
    model: {
      value: _vm.form.productName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "productName", $$v);
      },
      expression: "form.productName"
    }
  }, [_c('div', {
    style: {
      position: 'relative',
      width: '9.6rem'
    },
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('span', {
    staticClass: "form-red-star"
  }, [_vm._v("*")]), _vm._v(" " + i18n.tc("209") + " ")])])], 1), _vm.codeMap['420002'] ? _c('group', [_c('datetime', {
    attrs: {
      "title": i18n.tc("200"),
      "format": "YYYY-MM-DD",
      "readonly": true
    },
    model: {
      value: _vm.form.warranty_start_date,
      callback: function ($$v) {
        _vm.$set(_vm.form, "warranty_start_date", $$v);
      },
      expression: "form.warranty_start_date"
    }
  })], 1) : _vm._e(), _vm.codeMap['420001'] ? _c('Group', [_c('datetime', {
    attrs: {
      "title": i18n.tc("201"),
      "readonly": true,
      "format": "YYYY-MM-DD"
    },
    model: {
      value: _vm.form.warranty_end_date,
      callback: function ($$v) {
        _vm.$set(_vm.form, "warranty_end_date", $$v);
      },
      expression: "form.warranty_end_date"
    }
  })], 1) : _vm._e(), _vm.codeMap['420006'] ? _c('Group', [_c('datetime', {
    attrs: {
      "title": i18n.tc("202"),
      "format": "YYYY-MM-DD",
      "readonly": true
    },
    model: {
      value: _vm.form.purchasing_date,
      callback: function ($$v) {
        _vm.$set(_vm.form, "purchasing_date", $$v);
      },
      expression: "form.purchasing_date"
    }
  })], 1) : _vm._e(), _vm.codeMap['420004'] ? _c('Group', [_c('datetime', {
    attrs: {
      "title": i18n.tc("203"),
      "format": "YYYY-MM-DD",
      "readonly": true
    },
    model: {
      value: _vm.form.delivery_date,
      callback: function ($$v) {
        _vm.$set(_vm.form, "delivery_date", $$v);
      },
      expression: "form.delivery_date"
    }
  })], 1) : _vm._e(), _vm.codeMap['420005'] ? _c('Group', [_c('datetime', {
    attrs: {
      "title": i18n.tc("204"),
      "format": "YYYY-MM-DD",
      "readonly": true
    },
    model: {
      value: _vm.form.install_date,
      callback: function ($$v) {
        _vm.$set(_vm.form, "install_date", $$v);
      },
      expression: "form.install_date"
    }
  })], 1) : _vm._e(), _vm.codeMap['420003'] ? _c('Group', [_c('datetime', {
    attrs: {
      "title": i18n.tc("205"),
      "format": "YYYY-MM-DD",
      "readonly": true
    },
    model: {
      value: _vm.form.production_date,
      callback: function ($$v) {
        _vm.$set(_vm.form, "production_date", $$v);
      },
      expression: "form.production_date"
    }
  })], 1) : _vm._e(), _c('group', [_c(__unplugin_components_0, {
    attrs: {
      "title": i18n.tc("574"),
      "disabled": true,
      "placeholder": i18n.tc("575"),
      "value": _vm.form.warranty_type + '',
      "format": function (v) {
        return {
          name: v.name,
          value: String(v.value)
        };
      },
      "data": _vm.warrantyList
    },
    on: {
      "input": function ($event) {
        _vm.form.warranty_type = $event;
      }
    }
  })], 1), _c('group', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.customField.length,
      expression: "customField.length"
    }]
  }, [_c(__unplugin_components_1, {
    staticStyle: {
      "padding": "10px 15px"
    },
    attrs: {
      "extFields": _vm.customField
    }
  })], 1)], 1), _c('div', {
    staticClass: "bottom-bar",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('div', {
    staticClass: "btn-body"
  }, [_c('x-button', {
    staticClass: "main-color no-border-radius",
    attrs: {
      "type": "default"
    },
    nativeOn: {
      "click": function ($event) {
        _vm.currValue = false;
      }
    }
  }, [_vm._v(" " + i18n.tc("11") + " ")])], 1), _c('div', {
    staticClass: "btn-body"
  }, [_c('x-button', {
    staticClass: "no-border-radius",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function ($event) {
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_vm._v(i18n.tc("235"))])], 1)])])], 1)]), _c('CheckProduct', {
    attrs: {
      "isProductionFromcustomer": 0,
      "selectCustomerId": _vm.selectCustomerId,
      "check": false
    },
    on: {
      "on-check": _vm.selectProduct
    },
    model: {
      value: _vm.isShowSelectProductModal,
      callback: function ($$v) {
        _vm.isShowSelectProductModal = $$v;
      },
      expression: "isShowSelectProductModal"
    }
  }), _c('ModalScan', {
    on: {
      "result": _vm.handleBackResult
    },
    model: {
      value: _vm.showScan,
      callback: function ($$v) {
        _vm.showScan = $$v;
      },
      expression: "showScan"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };